import { LLMModelInfo, LLMProvider } from '../types';

export const parseLLMModels = (value?: string): LLMModelInfo[] => {
  try {
    const parsed: unknown = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed as LLMModelInfo[] : [];
  } catch {
    return [];
  }
};

export const enabledLLMModels = (provider?: Pick<LLMProvider, 'models'>): LLMModelInfo[] => (
  parseLLMModels(provider?.models).filter(model => !model.disabled && typeof model.name === 'string' && model.name.trim() !== '')
);

export const selectableLLMProviders = (providers: LLMProvider[]): LLMProvider[] => (
  providers.filter(provider => !provider.disabled && enabledLLMModels(provider).length > 0)
);
